/**
 * url拼接
 * @param path
 * @param param
 */
export const buildPath = (path: any = '', param?: object) => {
  if (param && Object.keys(param).length > 0) {
    const dataArray = Object.keys(param).reduce((result, prop) => {
      result.push(`${prop}=${param[prop]}`);
      return result;
    }, []);
    return `${path}?${dataArray.join('&')}`;
  }
  return path;
};
